'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iconChat = require('../image-strings/icon-chat');

var _iconChat2 = _interopRequireDefault(_iconChat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * AvatarWrapper
 * @returns {React.Element} AvatarWrapper component for bot/agent actions
 *
 * @param {string} src The avatar image src
 * @public
 */
var AvatarWrapper = function AvatarWrapper(_ref) {
  var children = _ref.children,
      hidden = _ref.hidden,
      src = _ref.src,
      onImageError = _ref.onImageError;

  return _react2.default.createElement(
    'div',
    { className: 'avatar-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'avatar-wrapper-icon' },
      !hidden && _react2.default.createElement('img', { className: 'avatar-image', src: src || _iconChat2.default, alt: '', onError: function onError() {
          return onImageError();
        } })
    ),
    _react2.default.createElement(
      'div',
      { className: 'avatar-wrapper-children' },
      children
    )
  );
};

/**
* Property definitions.
*
* @type {Object}
* @public
*/
AvatarWrapper.propTypes = {
  children: _propTypes2.default.node.isRequired,
  hidden: _propTypes2.default.bool,
  src: _propTypes2.default.string,
  onImageError: _propTypes2.default.func
};

exports.default = AvatarWrapper;